export class Vector {
  constructor(x, y) {
    if (x == undefined || y == undefined) {
      throw new Error("Vector parametres incorrect");
    }

    this._x = x;
    this._y = y;
  }

  x() {
    return this._x;
  }
  y() {
    return this._y;
  }

  length2() {
    if (this._length2 === undefined) {
      this._length2 = this._x * this._x + this._y * this._y;
    }
    return this._length2;
  }

  length() {
    if (this._length === undefined) {
      this._length = Math.sqrt(this.length2());
    }
    return this._length;
  }

  normalize() {
    this._x = this._x / this.length();
    this._y = this._y / this.length();
    return this;
  }

  reverse() {
    this._x = -this._x;
    this._y = -this._y;
    return this;
  }

  get_rotated(angle, sin, cos) {
    if ((sin && cos) == undefined) {
      if (angle == undefined) {
        throw new Error("Angle does not defined");
      }
      sin = Math.sin(angle);
      cos = Math.cos(angle);
    }
    return new Vector(
      this.x() * cos - this.y() * sin,
      this.x() * sin + this.y() * cos
    );
  }
}
